import React, { PropsWithChildren, useMemo } from 'react';
import { TableBodyContext } from './TableBody.context';

type TableBodyProps = {
  id?: string;
  className?: string;
};

export function TableBody({ id, className, children }: PropsWithChildren<TableBodyProps>) {
  const ctx = useMemo(() => ({ isTableBody: true }), []);
  return (
    <TableBodyContext.Provider value={ctx}>
      {/* we need redundant roles for responsive tables! */}
      <tbody id={id} className={className || 'tables__body'}>
        {children}
      </tbody>
    </TableBodyContext.Provider>
  );
}
